module.exports = __webpack_public_path__ + "static/media/Connoisseur.f8663fcd.jpg";